export default "__VITE_PUBLIC_ASSET__0d100520__"